import { AiFillHome } from "react-icons/ai";
import { MdPlaylistPlay } from "react-icons/md";
import { AiFillHeart } from "react-icons/ai";
import { MdHistory } from "react-icons/md";
import { MdOutlineWatchLater } from "react-icons/md";

export const Navigations = [
  {
    id: 1,
    icon: AiFillHome,
    title: "Home",
    route: "videoList",
  },
  {
    id: 2,
    icon: MdPlaylistPlay,
    title: "Playlists",
    route: "playList",
  },
  {
    id: 3,
    icon: AiFillHeart,
    title: "Liked",
    route: "liked",
  },
  {
    id: 4,
    icon: MdHistory,
    title: "History",
    route: "history",
  },
  {
    id: 5,
    icon: MdOutlineWatchLater,
    title: "Watch Later",
    route: "watchlater",
  },
];

export const TagsTitle = [
  { id: 1, tagTitle: "All" },
  { id: 2, tagTitle: "Astrophysics" },
  { id: 3, tagTitle: "Astrobiology" },
  { id: 4, tagTitle: "Cosmic Mysteries" },
  { id: 5, tagTitle: "Universe" },
];

export const YoutubeData =[
    {
      "kind": "youtube#searchResult",
      "etag": "IrXWxsx0ziWiikdnKFggqKoi_a0",
      "id": {
        "kind": "youtube#playlist",
        "playlistId": "PLu0W_9lII9agx66oZnT6IyhcMIbUMNMdt"
      },
      "snippet": {
        "publishedAt": "2021-08-13T12:14:26Z",
        "channelId": "UCeVMnSShP_Iviwkknt83cww",
        "title": "React Js Tutorials in Hindi",
        "description": "Complete React Course by CodeWithHarry - Learn ReactJs from scratch in 2022 for FREE. React is a free and open-source ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/-mJFZp84TIY/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/-mJFZp84TIY/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/-mJFZp84TIY/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "CodeWithHarry",
        "liveBroadcastContent": "none",
        "publishTime": "2021-08-13T12:14:26Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "XLtCZnyEx4NrjJAnpMSLYhVr4uA",
      "id": {
        "kind": "youtube#playlist",
        "playlistId": "PLC3y8-rFHvwgg3vaYJgHGnModB54rxOk3"
      },
      "snippet": {
        "publishedAt": "2018-10-29T12:01:47Z",
        "channelId": "UC80PWRj_ZU8Zu0HSMNVwKWw",
        "title": "ReactJS Tutorial for Beginners",
        "description": "React is an open source javascript library for building user interfaces. React is a project created and maintained by Facebook.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/QFaFIcGhPoM/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/QFaFIcGhPoM/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/QFaFIcGhPoM/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Codevolution",
        "liveBroadcastContent": "none",
        "publishTime": "2018-10-29T12:01:47Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "UN6gopm_SslQipgFDbgV4CcxTmQ",
      "id": {
        "kind": "youtube#playlist",
        "playlistId": "PLwGdqUZWnOp3aROg4wypcRhZqJG3ajZWJ"
      },
      "snippet": {
        "publishedAt": "2020-05-03T06:44:56Z",
        "channelId": "UCwfaAHy4zQUb2APNOGXUCCA",
        "title": "React JS Tutorial in Hindi 2021",
        "description": "Welcome to React JS tutorial for beginners in Hindi in 2021. React is a JavaScript library for building user interfaces.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/tiLWCNFzThE/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/tiLWCNFzThE/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/tiLWCNFzThE/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Thapa Technical",
        "liveBroadcastContent": "none",
        "publishTime": "2020-05-03T06:44:56Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "elYm_FMIpEVM1mVK6IjQsNCRyF8",
      "id": {
        "kind": "youtube#video",
        "videoId": "Ke90Tje7VS0"
      },
      "snippet": {
        "publishedAt": "2018-07-16T16:51:44Z",
        "channelId": "UCWv7vMbMWH4-V0ZXdmDpPBA",
        "title": "React JS - React Tutorial for Beginners",
        "description": "React JS Tutorial - Get up & running with React JS: the most popular JavaScript library in the world! - Want to master React?",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Ke90Tje7VS0/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Ke90Tje7VS0/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Ke90Tje7VS0/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Programming with Mosh",
        "liveBroadcastContent": "none",
        "publishTime": "2018-07-16T16:51:44Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "PD6fgkJqFlGxndIgXW6qaraAYiE",
      "id": {
        "kind": "youtube#video",
        "videoId": "RGKi6LSPDLU"
      },
      "snippet": {
        "publishedAt": "2021-04-14T14:43:19Z",
        "channelId": "UCeVMnSShP_Iviwkknt83cww",
        "title": "React Tutorial in Hindi 🔥🔥",
        "description": "Join my Recently launched Complete & Free React Course with 3 Projects: ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/RGKi6LSPDLU/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/RGKi6LSPDLU/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/RGKi6LSPDLU/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "CodeWithHarry",
        "liveBroadcastContent": "none",
        "publishTime": "2021-04-14T14:43:19Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "jCVLhI-gggBOCNwMK0RoJuAiG0U",
      "id": {
        "kind": "youtube#video",
        "videoId": "bMknfKXIFA8"
      },
      "snippet": {
        "publishedAt": "2022-01-10T14:47:57Z",
        "channelId": "UC8butISFwT-Wl7EV0hUK0BQ",
        "title": "React Course - Beginner&#39;s Tutorial for React JavaScript Library [2022]",
        "description": "Learn React by building eight real-world projects and solving 140+ coding challenges. You can also follow this course ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/bMknfKXIFA8/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/bMknfKXIFA8/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/bMknfKXIFA8/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "freeCodeCamp.org",
        "liveBroadcastContent": "none",
        "publishTime": "2022-01-10T14:47:57Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "w4xkudyT5VrpXIqGjtelGITzYd8",
      "id": {
        "kind": "youtube#video",
        "videoId": "gY5sGvq-8h8"
      },
      "snippet": {
        "publishedAt": "2021-12-17T16:07:05Z",
        "channelId": "UCBwmMxybNva6P_5VmxjzwqA",
        "title": "ReactJS Tutorial for Beginners | Learn React in 2.5 Hours | Part 1",
        "description": "Project at : https://github.com/apna-college/ReactJS Java Placement Course ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/gY5sGvq-8h8/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/gY5sGvq-8h8/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/gY5sGvq-8h8/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Apna College",
        "liveBroadcastContent": "none",
        "publishTime": "2021-12-17T16:07:05Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "-fJWW0ilOcx3vXOzhxNKVupCPVE",
      "id": {
        "kind": "youtube#video",
        "videoId": "F18Rxw6ftcM"
      },
      "snippet": {
        "publishedAt": "2021-12-17T12:43:41Z",
        "channelId": "UCWCGvAu1NDCldmLasELk62g",
        "title": "🔥 React Tutorial in Hindi for Beginners | Complete React JS Tutorial in Hindi with Project",
        "description": "Hosting Link and coupon code ----------------------------------------------------- Hosting link: http://www.hostinger.in/techgun Coupon ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/F18Rxw6ftcM/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/F18Rxw6ftcM/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/F18Rxw6ftcM/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Tech Gun",
        "liveBroadcastContent": "none",
        "publishTime": "2021-12-17T12:43:41Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "m_wa_Hc-6iof92rOHiMf8qjIA9w",
      "id": {
        "kind": "youtube#video",
        "videoId": "ygsrt33azpk"
      },
      "snippet": {
        "publishedAt": "2021-10-24T10:30:09Z",
        "channelId": "UC0T6MVd3wQDB5ICAe45OxaQ",
        "title": "React JS Full Tutorial for Beginners (2022🔥) | What is React JS? - Learn React JS in 9 Hours",
        "description": "In this detailed React JS tutorial, you will learn React JS in Hindi. This React JS crash course will help you get an overview of what ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/ygsrt33azpk/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/ygsrt33azpk/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/ygsrt33azpk/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "WsCube Tech",
        "liveBroadcastContent": "none",
        "publishTime": "2021-10-24T10:30:09Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "zKY9aW0pmcCPB9irNN0_3tkL-9I",
      "id": {
        "kind": "youtube#video",
        "videoId": "0riHps91AzE"
      },
      "snippet": {
        "publishedAt": "2021-05-14T07:40:45Z",
        "channelId": "UChPxqdfDbulLE9PyUqhijWw",
        "title": "Learn React JS with Project in 2 Hours  | React Tutorial for Beginners | React Project Crash Course",
        "description": "This video is a complete React Crash Course for beginners. The video covers different React Topics and implementation in one ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/0riHps91AzE/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/0riHps91AzE/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/0riHps91AzE/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Dipesh Malvia",
        "liveBroadcastContent": "none",
        "publishTime": "2021-05-14T07:40:45Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "DD8JX0aFjFiL7Agkpwb5sIry-nU",
      "id": {
        "kind": "youtube#video",
        "videoId": "b9eMGE7QtTk"
      },
      "snippet": {
        "publishedAt": "2022-03-04T11:06:59Z",
        "channelId": "UCmXmlB4-HJytD7wek0Uo97A",
        "title": "React JS Full Course 2022 | Build an App and Master React in 1 Hour",
        "description": "Are you wondering how to become a React developer? Look no further, and get all the info in one video. The first 1000 people to ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/b9eMGE7QtTk/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/b9eMGE7QtTk/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/b9eMGE7QtTk/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "JavaScript Mastery",
        "liveBroadcastContent": "none",
        "publishTime": "2022-03-04T11:06:59Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "No6xWXeot5mH0Os9jNhG1x6LL4Q",
      "id": {
        "kind": "youtube#video",
        "videoId": "w7ejDZ8SWv8"
      },
      "snippet": {
        "publishedAt": "2021-01-18T19:01:11Z",
        "channelId": "UC29ju8bIPH5as8OGnQzwJyA",
        "title": "React JS Crash Course",
        "description": "Get started with React in this crash course. We will be building a task tracker app and look at components, props, state, hooks, ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/w7ejDZ8SWv8/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/w7ejDZ8SWv8/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/w7ejDZ8SWv8/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Traversy Media",
        "liveBroadcastContent": "none",
        "publishTime": "2021-01-18T19:01:11Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "MRzywHteY5ONfr0WLbVOFReL_m8",
      "id": {
        "kind": "youtube#video",
        "videoId": "GiyL4KFRNBA"
      },
      "snippet": {
        "publishedAt": "2021-04-14T08:11:29Z",
        "channelId": "UCvHX2bCZG2m9ddUhwxudKYA",
        "title": "React js full tutorial in Hindi | Complete Course",
        "description": "This is react js complete course in the Hindi language made by anil Sidhu. Here you can learn to react in one video to all topics ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/GiyL4KFRNBA/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/GiyL4KFRNBA/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/GiyL4KFRNBA/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Code Step By Step",
        "liveBroadcastContent": "none",
        "publishTime": "2021-04-14T08:11:29Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "Hjius0ne7YR0Yf-b05zYhqqLLOo",
      "id": {
        "kind": "youtube#video",
        "videoId": "hQAHSlTtcmY"
      },
      "snippet": {
        "publishedAt": "2019-10-22T16:00:07Z",
        "channelId": "UCFbNIlppjAuEX4znoulh0Cw",
        "title": "Learn React In 30 Minutes",
        "description": "IMPORTANT: Full React Course: https://courses.webdevsimplified.com/learn-react-today In this video I will be covering all of the ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/hQAHSlTtcmY/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/hQAHSlTtcmY/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/hQAHSlTtcmY/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Web Dev Simplified",
        "liveBroadcastContent": "none",
        "publishTime": "2019-10-22T16:00:07Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "X2lwxXePem63v7-7WsJfZ5AJseo",
      "id": {
        "kind": "youtube#video",
        "videoId": "EHTWMpD6S_0"
      },
      "snippet": {
        "publishedAt": "2021-07-21T10:30:02Z",
        "channelId": "UCwfaAHy4zQUb2APNOGXUCCA",
        "title": "🔴 Complete React JS Tutorial in Hindi with 5 Projects in 2022",
        "description": "Welcome, Complete React JS Tutorial for Beginners In Hindi In 2022. Learn Complete React with 5 Projects from Basic to ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/EHTWMpD6S_0/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/EHTWMpD6S_0/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/EHTWMpD6S_0/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Thapa Technical",
        "liveBroadcastContent": "none",
        "publishTime": "2021-07-21T10:30:02Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "D4KnkH0wmidVmWRC5FUcEj8HS3A",
      "id": {
        "kind": "youtube#video",
        "videoId": "NZqMVUEiDIw"
      },
      "snippet": {
        "publishedAt": "2022-09-27T16:00:15Z",
        "channelId": "UCFbNIlppjAuEX4znoulh0Cw",
        "title": "Are You Making This React State Mistake?",
        "description": "React state is complex enough to understand how it works, but it is even harder to write good state code in React. I oftentimes see ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/NZqMVUEiDIw/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/NZqMVUEiDIw/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/NZqMVUEiDIw/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Web Dev Simplified",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-27T16:00:15Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "R1Hiec0PII80G36xkKyBZw505mE",
      "id": {
        "kind": "youtube#video",
        "videoId": "1r79Eqw6tfg"
      },
      "snippet": {
        "publishedAt": "2022-01-10T04:30:00Z",
        "channelId": "UC7A41-L2rIlxXGM3bas_WsQ",
        "title": "React JS In Telugu",
        "description": "Hey Everyone, This video is all about explanation of react js tutorial in telugu. This series will be continued please stay tune :) for ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/1r79Eqw6tfg/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/1r79Eqw6tfg/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/1r79Eqw6tfg/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Telugu Skillhub",
        "liveBroadcastContent": "none",
        "publishTime": "2022-01-10T04:30:00Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "BqXp9zAd2AxwML24Brr3597gYcA",
      "id": {
        "kind": "youtube#video",
        "videoId": "Dorf8i6lCuk"
      },
      "snippet": {
        "publishedAt": "2021-05-05T15:00:03Z",
        "channelId": "UCSJbGtTlrDami-tDGPUV9-w",
        "title": "React Crash Course for Beginners 2021 - Learn ReactJS from Scratch in this 100% Free Tutorial!",
        "description": "Get Started with React.js and learn how to build amazing websites with ReactJS! Full Project included, 100% free! Join our ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Dorf8i6lCuk/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Dorf8i6lCuk/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Dorf8i6lCuk/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Academind",
        "liveBroadcastContent": "none",
        "publishTime": "2021-05-05T15:00:03Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "BFGVEt3dPBSEPy5-S9HOlgMCjb4",
      "id": {
        "kind": "youtube#video",
        "videoId": "fSp2C7QPH8M"
      },
      "snippet": {
        "publishedAt": "2019-07-14T08:30:00Z",
        "channelId": "UCkw4JCwteGrDHIsyIIKo4tQ",
        "title": "React.js Full Course for Beginners | Learn React.js in 4 Hours | React.js Tutorial | Edureka",
        "description": "Edureka ReactJS Training (Use code: YOUTUBE20) - https://www.edureka.co/reactjs-redux-certification-training ** This Edureka ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/fSp2C7QPH8M/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/fSp2C7QPH8M/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/fSp2C7QPH8M/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "edureka!",
        "liveBroadcastContent": "none",
        "publishTime": "2019-07-14T08:30:00Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "vxadrf77EVuxGutKKy5ZtiEChuk",
      "id": {
        "kind": "youtube#video",
        "videoId": "4UZrsTqkcW4"
      },
      "snippet": {
        "publishedAt": "2020-10-06T14:16:07Z",
        "channelId": "UC8butISFwT-Wl7EV0hUK0BQ",
        "title": "Full React Course 2020 - Learn Fundamentals, Hooks, Context API, React Router, Custom Hooks",
        "description": "Learn the basics of React in this comprehensive course. You will learn about fundamentals, hooks, context API, react router, ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/4UZrsTqkcW4/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/4UZrsTqkcW4/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/4UZrsTqkcW4/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "freeCodeCamp.org",
        "liveBroadcastContent": "none",
        "publishTime": "2020-10-06T14:16:07Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "3qFl54Xb192_kyJobgWpS1yi8lU",
      "id": {
        "kind": "youtube#video",
        "videoId": "N3AkSS5hXMA"
      },
      "snippet": {
        "publishedAt": "2018-06-27T04:05:47Z",
        "channelId": "UCWv7vMbMWH4-V0ZXdmDpPBA",
        "title": "What Is React (React js) &amp; Why Is It So Popular?",
        "description": "What is React (React js)? This video explains it in 5 Minutes! React tutorial for beginners: https://youtu.be/Ke90Tje7VS0 ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/N3AkSS5hXMA/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/N3AkSS5hXMA/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/N3AkSS5hXMA/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Programming with Mosh",
        "liveBroadcastContent": "none",
        "publishTime": "2018-06-27T04:05:47Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "5YIizLplFXYDKGrdvo8GJGzLX3U",
      "id": {
        "kind": "youtube#playlist",
        "playlistId": "PLbGui_ZYuhignjLLXTJWkRJKN-SgAqClL"
      },
      "snippet": {
        "publishedAt": "2019-02-05T10:17:37Z",
        "channelId": "UCc5FkTYiWH5L3Gk5IyW6Rmw",
        "title": "React JS (Hindi)",
        "description": "",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/IcwiDCSWI-Y/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/IcwiDCSWI-Y/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/IcwiDCSWI-Y/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Geeky Shows",
        "liveBroadcastContent": "none",
        "publishTime": "2019-02-05T10:17:37Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "GsV8eL0CeLpI1-3-yTXxDP-Ihfo",
      "id": {
        "kind": "youtube#video",
        "videoId": "TjnWtDWFZFc"
      },
      "snippet": {
        "publishedAt": "2020-06-27T16:21:36Z",
        "channelId": "UC-Gn7EgShAINFthjuzxi9PQ",
        "title": "🔥 🔥 Complete React Js with Project tutorial in hindi 🔥 🔥 + Backend Spring boot",
        "description": "In this video , we are going to learn complete react js with project in one video. we will cover all the important concepts in one ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/TjnWtDWFZFc/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/TjnWtDWFZFc/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/TjnWtDWFZFc/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Learn Code With Durgesh",
        "liveBroadcastContent": "none",
        "publishTime": "2020-06-27T16:21:36Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "xrcqtne41tc0Xej-_X08roINYcM",
      "id": {
        "kind": "youtube#video",
        "videoId": "0yeua71j5b4"
      },
      "snippet": {
        "publishedAt": "2021-11-10T13:30:01Z",
        "channelId": "UCJUmE61LxhbhudzUugHL2wQ",
        "title": "How to Master ReactJS?",
        "description": "Learn Full Stack Development on codedamn: https://cdm.sh/fullstack Free ReactJS Course: https://cdm.sh/react Free NextS ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/0yeua71j5b4/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/0yeua71j5b4/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/0yeua71j5b4/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "codedamn",
        "liveBroadcastContent": "none",
        "publishTime": "2021-11-10T13:30:01Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "JHhJK-9Z7qIKN2bkoOBjF-JNKhI",
      "id": {
        "kind": "youtube#video",
        "videoId": "nvHeB32ICDM"
      },
      "snippet": {
        "publishedAt": "2019-08-22T12:26:25Z",
        "channelId": "UCXgGY0wkgOzynnHvSEVmE3A",
        "title": "ReactJS Crash Course",
        "description": "Welcome to the crash course on reactJS. Here is the link for exercise files, final project, and discussion section for this course: ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/nvHeB32ICDM/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/nvHeB32ICDM/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/nvHeB32ICDM/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Hitesh Choudhary",
        "liveBroadcastContent": "none",
        "publishTime": "2019-08-22T12:26:25Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "gHKv_28thJSZ_cY2ydupvXqJp1Y",
      "id": {
        "kind": "youtube#video",
        "videoId": "VyeA0tVreYw"
      },
      "snippet": {
        "publishedAt": "2021-08-26T12:37:28Z",
        "channelId": "UCkw4JCwteGrDHIsyIIKo4tQ",
        "title": "ReactJS Full Course in 7 Hours | Learn React js | React.js Training | Edureka",
        "description": "ReactJS Training - https://www.edureka.co/reactjs-redux-certification-training This Edureka React JS Tutorial for Beginners will ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/VyeA0tVreYw/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/VyeA0tVreYw/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/VyeA0tVreYw/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "edureka!",
        "liveBroadcastContent": "none",
        "publishTime": "2021-08-26T12:37:28Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "VFsCjASN6X_STKurxxy_yTukZuc",
      "id": {
        "kind": "youtube#video",
        "videoId": "Y6aYx_KKM7A"
      },
      "snippet": {
        "publishedAt": "2019-09-04T14:30:00Z",
        "channelId": "UCsvqVGtbbyHaMoevxPAq9Fg",
        "title": "What Is ReactJS? | ReactJS Basics | Learn ReactJS | ReactJS Tutorial For Beginners | Simplilearn",
        "description": "In this video, we learn all about ReactJS, it's features and some basic concepts required to build a React Application. React is a ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Y6aYx_KKM7A/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Y6aYx_KKM7A/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Y6aYx_KKM7A/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Simplilearn",
        "liveBroadcastContent": "none",
        "publishTime": "2019-09-04T14:30:00Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "d77Pje6NqkmRKOLjPX01iAttCy8",
      "id": {
        "kind": "youtube#video",
        "videoId": "Y_r-51IzfGk"
      },
      "snippet": {
        "publishedAt": "2021-08-20T14:17:25Z",
        "channelId": "UCeVMnSShP_Iviwkknt83cww",
        "title": "How much JavaScript is needed to learn React?",
        "description": "How much Javascript to learn for react. Can you learn react along with Javascript? This video will answer all these questions!",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Y_r-51IzfGk/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Y_r-51IzfGk/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Y_r-51IzfGk/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "CodeWithHarry",
        "liveBroadcastContent": "none",
        "publishTime": "2021-08-20T14:17:25Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "Eq_ETo8kYAZk0MRVMqxgd0k9Cns",
      "id": {
        "kind": "youtube#video",
        "videoId": "MRIMT0xPXFI"
      },
      "snippet": {
        "publishedAt": "2019-12-18T18:30:01Z",
        "channelId": "UCRLEADhMcb8WUdnQ5_Alk7g",
        "title": "Learn REACT JS in just 5 MINUTES (2020)",
        "description": "You cannot MASTER React in 5 minutes, but here are all the main components you need to understand to call yourself a React ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/MRIMT0xPXFI/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/MRIMT0xPXFI/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/MRIMT0xPXFI/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Aaron Jack",
        "liveBroadcastContent": "none",
        "publishTime": "2019-12-18T18:30:01Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "J2zox_nI7dQh7QXF_X-go_3NtIs",
      "id": {
        "kind": "youtube#video",
        "videoId": "RVFAyFWO4go"
      },
      "snippet": {
        "publishedAt": "2021-09-10T13:00:10Z",
        "channelId": "UCY38RvRIxYODO4penyxUwTg",
        "title": "React JS Full Course for Beginners | Complete All-in-One Tutorial | 9 Hours",
        "description": "This React JS Full Course for Beginners is an all-in-one beginner tutorial and complete course full of nearly 9 hours of React JS ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/RVFAyFWO4go/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/RVFAyFWO4go/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/RVFAyFWO4go/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Dave Gray",
        "liveBroadcastContent": "none",
        "publishTime": "2021-09-10T13:00:10Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "7Fur6Jsab2tl1c8y4SlqJ33nF5M",
      "id": {
        "kind": "youtube#playlist",
        "playlistId": "PL_-VfJajZj0UXjlKfBwFX73usByw3Ph9Q"
      },
      "snippet": {
        "publishedAt": "2021-09-15T09:55:57Z",
        "channelId": "UCNSCWwgW-rwmoE3Yc4WmJhw",
        "title": "ReactJS 2022",
        "description": "Khoá học ReactJS mới nhất 2022, mục tiêu của khoá này là giúp các bạn có thể đầy đủ hành trang để đi làm.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/x0fSBAgBrOQ/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/x0fSBAgBrOQ/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/x0fSBAgBrOQ/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "F8 Official",
        "liveBroadcastContent": "none",
        "publishTime": "2021-09-15T09:55:57Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "eX39SaNpkbM94FLL8nr9--7c3nU",
      "id": {
        "kind": "youtube#video",
        "videoId": "jLS0TkAHvRg"
      },
      "snippet": {
        "publishedAt": "2022-04-10T13:30:17Z",
        "channelId": "UC80PWRj_ZU8Zu0HSMNVwKWw",
        "title": "React 18 Fundamentals Crash Course 2022",
        "description": "Courses - https://learn.codevolution.dev/ Support UPI - https://support.codevolution.dev/ Support Paypal ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/jLS0TkAHvRg/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/jLS0TkAHvRg/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/jLS0TkAHvRg/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Codevolution",
        "liveBroadcastContent": "none",
        "publishTime": "2022-04-10T13:30:17Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "DMkqTLQCEsXrdzemulNaXUR306k",
      "id": {
        "kind": "youtube#video",
        "videoId": "Tn6-PIqc4UM"
      },
      "snippet": {
        "publishedAt": "2020-09-08T19:06:55Z",
        "channelId": "UCsBjURrPoezykLs9EqgamOA",
        "title": "React in 100 Seconds",
        "description": "React is a little JavaScript library with a big influence over the webdev world. Learn the basics of React in 100 Seconds ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Tn6-PIqc4UM/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Tn6-PIqc4UM/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Tn6-PIqc4UM/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Fireship",
        "liveBroadcastContent": "none",
        "publishTime": "2020-09-08T19:06:55Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "ipb-f0C50KISs8vJeFcSQvVId4Y",
      "id": {
        "kind": "youtube#playlist",
        "playlistId": "PL4cUxeGkcC9gZD-Tvwfod2gaISzfRiP9d"
      },
      "snippet": {
        "publishedAt": "2020-12-21T08:37:55Z",
        "channelId": "UCW5YeuERMmlnqo4oq8vwUpg",
        "title": "Full Modern React Tutorial",
        "description": "Hey gang, in this full React tutorial series, I'll take you from novice to ninja. We'll cover all the basics - what React is, setting up, ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/j942wKiXFu8/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/j942wKiXFu8/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/j942wKiXFu8/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "The Net Ninja",
        "liveBroadcastContent": "none",
        "publishTime": "2020-12-21T08:37:55Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "5Vvhfyq_ffwkYhAKh8xsgRmDdps",
      "id": {
        "kind": "youtube#video",
        "videoId": "-mJFZp84TIY"
      },
      "snippet": {
        "publishedAt": "2021-08-13T12:20:25Z",
        "channelId": "UCeVMnSShP_Iviwkknt83cww",
        "title": "Introduction to React Js + Installation | Complete React Course in Hindi #1",
        "description": "Complete react course: In this react course, we will see how to use react using projects. React is an amazing library for creating ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/-mJFZp84TIY/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/-mJFZp84TIY/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/-mJFZp84TIY/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "CodeWithHarry",
        "liveBroadcastContent": "none",
        "publishTime": "2021-08-13T12:20:25Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "pf7BNxb1pU3FyPupsLRTxZE8B38",
      "id": {
        "kind": "youtube#video",
        "videoId": "ABQLwlE8MUA"
      },
      "snippet": {
        "publishedAt": "2021-01-27T15:08:17Z",
        "channelId": "UCvmINlrza7JHB1zkIOuXEbw",
        "title": "React js in 3.5 hours | Full beginners tutorial",
        "description": "I'm starting a Coding RPG/Bootcamp! - https://simulator.dev\u200b Learn React js in 3.5 hours with this full tutorial for beginners!",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/ABQLwlE8MUA/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/ABQLwlE8MUA/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/ABQLwlE8MUA/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Mike Dane",
        "liveBroadcastContent": "none",
        "publishTime": "2021-01-27T15:08:17Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "BfHibs-8OrnMtTvKgwfxtzfS9TY",
      "id": {
        "kind": "youtube#playlist",
        "playlistId": "PL8p2I9GklV47BCAjiCtuV_liN9IwAl8pM"
      },
      "snippet": {
        "publishedAt": "2020-10-22T17:31:11Z",
        "channelId": "UCvHX2bCZG2m9ddUhwxudKYA",
        "title": "React tutorial for beginners in Hindi",
        "description": "React tutorial series for beginners in the Hindi language here you will get full Hindi tutorial of reactjs in Hindi, as well as this ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/9Tz2tY-ZEwQ/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/9Tz2tY-ZEwQ/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/9Tz2tY-ZEwQ/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Code Step By Step",
        "liveBroadcastContent": "none",
        "publishTime": "2020-10-22T17:31:11Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "0y-BITfNSDg_UyuRjdbyOnRb4QA",
      "id": {
        "kind": "youtube#video",
        "videoId": "s2skans2dP4"
      },
      "snippet": {
        "publishedAt": "2021-11-06T23:57:09Z",
        "channelId": "UCTZRcDjjkVajGL6wd76UnGg",
        "title": "React JS Explained In 10 Minutes",
        "description": "A list of the core concepts every React developer should have a solid grasp on. React Course: ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/s2skans2dP4/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/s2skans2dP4/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/s2skans2dP4/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Dennis Ivy",
        "liveBroadcastContent": "none",
        "publishTime": "2021-11-06T23:57:09Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "m4D3to0WnFVzAKAhaGvTqohlwgs",
      "id": {
        "kind": "youtube#video",
        "videoId": "I2UBjN5ER4s"
      },
      "snippet": {
        "publishedAt": "2020-08-11T17:00:02Z",
        "channelId": "UCsKsymTY_4BYR-wytLjex7A",
        "title": "React Website Tutorial - Beginner React JS Project Fully Responsive",
        "description": "Learn how to build a React website from scratch in this tutorial. We will use React Hooks and React Router for this beginner React ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/I2UBjN5ER4s/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/I2UBjN5ER4s/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/I2UBjN5ER4s/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Brian Design",
        "liveBroadcastContent": "none",
        "publishTime": "2020-08-11T17:00:02Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "eIUvA9ZbThZvd_7mioyu0k8giwM",
      "id": {
        "kind": "youtube#video",
        "videoId": "JR9wsVYp8RQ"
      },
      "snippet": {
        "publishedAt": "2021-12-14T17:00:10Z",
        "channelId": "UCFbNIlppjAuEX4znoulh0Cw",
        "title": "Do You Know Enough JavaScript To Learn React",
        "description": "JavaScript Simplified Course: https://javascriptsimplified.com React is hard to learn and it is made exponentially hard if you don't ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/JR9wsVYp8RQ/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/JR9wsVYp8RQ/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/JR9wsVYp8RQ/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Web Dev Simplified",
        "liveBroadcastContent": "none",
        "publishTime": "2021-12-14T17:00:10Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "9QidT598H9Ukp9AtzVbIlwLugg4",
      "id": {
        "kind": "youtube#video",
        "videoId": "yAbnoYfV99g"
      },
      "snippet": {
        "publishedAt": "2021-08-29T09:00:20Z",
        "channelId": "UCTZRcDjjkVajGL6wd76UnGg",
        "title": "Why &amp; When I Use React JS",
        "description": "React JS is not always my go to choice. In this video I explain why its a great tool for everyone to learn but also when I chose to ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/yAbnoYfV99g/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/yAbnoYfV99g/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/yAbnoYfV99g/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Dennis Ivy",
        "liveBroadcastContent": "none",
        "publishTime": "2021-08-29T09:00:20Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "OVpyRaVhTelTVURwiQOY8ncIvg8",
      "id": {
        "kind": "youtube#playlist",
        "playlistId": "PLgH5QX0i9K3rGtitufynBKMy5gAFpa1y8"
      },
      "snippet": {
        "publishedAt": "2020-11-18T00:06:34Z",
        "channelId": "UCEXwc6mNh7Lakj6lX-7a2Mg",
        "title": "React Full Course in Bangla",
        "description": "Subject: CSS3 Class: Anyone can try Lectured by: Anisul Islam Rubel (MSc in Software, Web & cloud, Finland) website ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/9IdczKQNg3o/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/9IdczKQNg3o/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/9IdczKQNg3o/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Anisul Islam",
        "liveBroadcastContent": "none",
        "publishTime": "2020-11-18T00:06:34Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "BfO0arF9V7TcofyoKMeEZMb2cCk",
      "id": {
        "kind": "youtube#video",
        "videoId": "HRhJVGjIraE"
      },
      "snippet": {
        "publishedAt": "2020-05-16T07:00:04Z",
        "channelId": "UCwfaAHy4zQUb2APNOGXUCCA",
        "title": "#22: Props in React Js in Hindi | React JS Project Netflix App Part #1 in Hindi in 2020",
        "description": "Welcome, React Props (aka react js properties). What is Props in React JS in Hindi? Components need to communicate (send ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/HRhJVGjIraE/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/HRhJVGjIraE/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/HRhJVGjIraE/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Thapa Technical",
        "liveBroadcastContent": "none",
        "publishTime": "2020-05-16T07:00:04Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "tJ5bP-F76vSWZ3MdTNiv0dz9ODE",
      "id": {
        "kind": "youtube#video",
        "videoId": "DLX62G4lc44"
      },
      "snippet": {
        "publishedAt": "2018-12-18T16:21:19Z",
        "channelId": "UC8butISFwT-Wl7EV0hUK0BQ",
        "title": "Learn React JS - Full Course for Beginners - Tutorial 2019",
        "description": "React.js is a JavaScript library for building dynamic web applications. Upon completion of this course, you'll know everything you ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/DLX62G4lc44/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/DLX62G4lc44/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/DLX62G4lc44/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "freeCodeCamp.org",
        "liveBroadcastContent": "none",
        "publishTime": "2018-12-18T16:21:19Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "LiH4z7DlwY3DBlRnrprLzWC4EQI",
      "id": {
        "kind": "youtube#video",
        "videoId": "UbLYdbOPLe8"
      },
      "snippet": {
        "publishedAt": "2022-03-30T13:30:16Z",
        "channelId": "UCHIbErciyS3Hs0kjAz-at5Q",
        "title": "React Lifecycle Methods Using Class &amp; Functional Components ( Frontend Interview Experience ) EP-01",
        "description": "React components have several lifecycle methods that you can override to run your code at a particular time in the process.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/UbLYdbOPLe8/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/UbLYdbOPLe8/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/UbLYdbOPLe8/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Technical Suneja",
        "liveBroadcastContent": "none",
        "publishTime": "2022-03-30T13:30:16Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "_V9HghpV4xZjKIr6yva8edRbhVA",
      "id": {
        "kind": "youtube#video",
        "videoId": "tbvguOj8C-o"
      },
      "snippet": {
        "publishedAt": "2021-06-28T11:35:40Z",
        "channelId": "UCqeTj_QAnNlmt7FwzNwHZnA",
        "title": "React JS Crash Course for Beginners - Build 4 Apps in 12 Hours (Redux, Firebase, Auth + More) [2022]",
        "description": "Too difficult? Watch my REACT BASICS 101 class for FREE with 1 month FREE SkillShare access (First 1000 people): ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/tbvguOj8C-o/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/tbvguOj8C-o/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/tbvguOj8C-o/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Sonny Sangha",
        "liveBroadcastContent": "none",
        "publishTime": "2021-06-28T11:35:40Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "sVmHXKk-lFrfpq4NfNd3drbhwFU",
      "id": {
        "kind": "youtube#video",
        "videoId": "jx5hdo50a2M"
      },
      "snippet": {
        "publishedAt": "2022-05-20T10:01:37Z",
        "channelId": "UCmXmlB4-HJytD7wek0Uo97A",
        "title": "Build and Deploy a React Admin Dashboard App With Theming, Tables, Charts, Calendar, Kanban and More",
        "description": "Every web developer needs to build a React Admin Dashboard Application. Learn how to create the best and most modern one ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/jx5hdo50a2M/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/jx5hdo50a2M/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/jx5hdo50a2M/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "JavaScript Mastery",
        "liveBroadcastContent": "none",
        "publishTime": "2022-05-20T10:01:37Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "etag": "zCqdbj5NWb7IvmbSqI-lvbZJv5g",
      "id": {
        "kind": "youtube#video",
        "videoId": "ubnpGkSHZ-0"
      },
      "snippet": {
        "publishedAt": "2022-03-21T19:23:21Z",
        "channelId": "UCsvqVGtbbyHaMoevxPAq9Fg",
        "title": "React JS Full Course For Beginners 2022 | Learn ReactJS In 5 Hours | React JS Tutorial |Simplilearn",
        "description": "Enrol for our FREE Courses with Completion Certificate: ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/ubnpGkSHZ-0/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/ubnpGkSHZ-0/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/ubnpGkSHZ-0/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Simplilearn",
        "liveBroadcastContent": "none",
        "publishTime": "2022-03-21T19:23:21Z"
      }
    }
  ]


